import moment from 'moment';
import { list } from '../../../../../../common/classes/request-builder';
import { StorageManager } from '../../../../../../common/storage-manager.class';
import { InputType, DropdownData } from '../../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '../../../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { environment } from '../../../../../../../environments/environment';
import { ClienteModel } from '../../../../../../models/cliente.model';
import { FincasModel } from '../../../../../../models/form-common/fincas.module';
import { SectorModel } from '../../../../../../models/form-common/sector.model';
import { ParcelasModel } from '../../../../../../models/form-common/parcelas.model';
import { MantenimientoModel } from '../../../../../../models/trabajadores/mantenimiento.model';
import { MaquinariaModel } from '../../../../../../models/trabajadores/maquinaria.model';
import { TareasBioModel } from '../../../../../../models/tareas/tareas-bio.model';

const PRODUCTOS_ORDENADOS = [
    'Suelta de Enemigos Naturales',
    'Feromonas Picudo',
    'P. Persimilis (Spidex)',
    'A. Californicus (Spical)',
    'A. Swirkii (Swirski-mite)',
    'Cryptolaemus montrouzieri (Cryptoline)',
    'Crysoperla sp (Crysoline)',
    'Bioknock',
    'Equisetum arvense',
    'Tigre',
    'Micorriza (Aegis irriga)',
    'Btu-8 (Bactofus)',
    'Vigor Plus (Btu-8)',
    'Ácid plus (Btu-8)',
    'Nematodo Steirnernema carpocapsae (Biorend leñosos)',
    'Nematodo Heterorhabditis bacteriophora (Biorend melolontha)',
    'Nematodo Steirnernema feltiae ( Biorend invernaderos)',
    'Nematodo Steirnernema feltiae (Entonem)',
    'Kira',
    'Cynoil',
    'Extracto canela (Amicosec)',
    'Isr altech',
    'Jabón potásico (Neptasila)',
    'Bacillus thurigiensis israelensis (Vectobac)',
    'Bacillus thurigiensis israelensis granulado(Vectomax)',
    'Piretinas naturales 3% (Pirecris)',
    'Nematodo Heterorhabditis bacteriophora (Biorend trips)',
    'Nematodo Steirnernema carpocapsae (Capsanem)',
    'Trichoderma (Condor)',
    'Anagyrus pseudococci (Anagline)',
    'Isonet z',
    'Veni biosulfur (Azufre 70%)',
    'Cryptobug',
    'Citripar',
    'Aphytis',
    'Orius Laevigatus',
    'Orius Majusculus',
    'Beauveria Bassiana',
    'Rhizobug 250 adulto',
    'Amblyseius Andersoni',
    'Larvas Chrysoperla',
    'Phytoseiulus Persimilis',
    'Trichogramma Achaeae',
    'Pheromona Duponchelia Fovealis',
    'Euzophera Pinguis',
    'Opogona Sacchari',
    'Californicus System',
    'Feromona + Kairomona Rhynchonex (Picudo)',
    'Margaronia Unionalis',
    'Scyphophorus Acupunctatus',
    'Zeuzera Pyrina',
    'Hypoaspis System',
    'Phyllocnistis Citrella',
    'Pupas Anagyrus Vladimirii',
    'Anthocoris Nemoralis',
    'Amblyseius Swirskii',
    'Nesidiocoris Tenuis',
    'Stratiolaelaps Scimitus',
    'Econex Cromática Amarilla 20 X25 CM',
    'Econex Triangular Blanca Plegable (Trampa sin Lámina)',
    'Econex Lámina para Trampa Triangular',
    'Feromonas Prays Citri',
    'Feromonas Planococus Ficus',
    'Placas 20 X 25 CM Negras CAJA contiene 500 Uds.',
    'Aphidius colemani (fauna auxiliar)',
    'Mitsei',
    'Alliance',
    'Talos',
].sort();

export class TareasBioFormDefinition {
    public readonly sectoresMultiple = environment.features.showTareasBioSectorMultiple;
    public readonly parcelasMultiple = environment.features.showTareasBioParcelaMultiple;

    public formType!: FormType;
    public model: Partial<TareasBioModel> = {};
    public formFields!: Form<TareasBioModel>;

    public clientes: DropdownData<ClienteModel> = list<ClienteModel>();
    public fincas: DropdownData<FincasModel> = list<FincasModel>();
    public sectores: DropdownData<SectorModel> = list<SectorModel>();
    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
    public trabajadores: DropdownData<MantenimientoModel> = list<MantenimientoModel>();
    public maquinarias: DropdownData<MaquinariaModel> = list<MaquinariaModel>();

    public productos: DropdownData<string> = list<string>(['...', null], ...PRODUCTOS_ORDENADOS);

    public tipoPlaga: DropdownData<string> = list<string>(
        ['...', null],
        'Ácaros',
        'Aguado',
        'Alternaria',
        'Amarre fruto',
        'Antracnosis',
        'Araña roja',
        'Ácaro blanco',
        'Caracoles',
        'Carencias',
        'Ceratitis',
        'Citripar',
        'Conservación',
        'Cotonet',
        'Cuajado',
        'Diaspinos',
        'Enfermedades tronco',
        'Engorde',
        'Estímulo',
        'Gusano blanco',
        'Gusano de alambre',
        'Gusano gris',
        'Heladas',
        'Hormigas',
        'Hongos',
        'Larvas Chrysoperla Carnea',
        'Malas hierbas',
        'Mejorante',
        'Melaza',
        'Minador',
        'Mosca blanca',
        'Mosca scatella',
        'Nutrición',
        'Oidio',
        'Orius Laevigatus',
        'Otiorrinco',
        'Piojo rojo de california',
        'Piojo blanco',
        'Phytophtora',
        'Phytoseiulus Persimilis',
        'Pulgones',
        'Sciara',
        'Trichoderma (Condor)',
        'Tipula',
        'Trips',
    );

    public estados: DropdownData<string> = list<string>('Planificado', 'Orden ficha', 'Aplicado');
    public estadoTarea: DropdownData<string> = list<string>(['...', null], 'Orden de Trabajo', 'Parte de Trabajo');

    public fieldNames: FormField<TareasBioModel>[] = [];
    public fieldLabels: string[] = [];

    public readonly appName = environment.appName;
    public readonly fincaName = environment.features.fincaName;
    public readonly sectorName = environment.features.sectorName;
    public readonly parcelasName = environment.features.parcelasName;
    public readonly clienteName = environment.features.clienteName;
    public readonly showTareasParcela = environment.features.showTareasParcela;
    public readonly showBioMotivo = environment.features.showBioMotivo;
    public readonly showBioOrden = environment.features.showBioOrden;
    public readonly hasClients = environment.features.hasClients;
    public readonly canSeeClientes = this.hasClients && (environment.features.userCanSeeClientes || StorageManager.getUser().rol === 'admin');

    private readonly client = StorageManager.getClient();
    private readonly user = StorageManager.getUser();

    constructor(type: FormType, model: Partial<TareasBioModel>) {
        this.formType = +type;
        this.model = model;

        this.formFields = {
            name: 'bio',
            header: 'Datos del bio',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    public calculateHorasTotales(): string {
        return this.formatHoursMinutes(
            this.normalizeTimeValue(this.model.hora_inicio),
            this.normalizeTimeValue(this.model.hora_fin),
        );
    }

    private getFormSections(): FormSection<TareasBioModel>[] {
        const sections: FormSection<TareasBioModel>[] = [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getLocationFields(),
                order: 1,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getDateAndWorkerFields(),
                order: 2,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getBioFields(),
                order: 3,
            },
            {
                name: '',
                width: 12,
                isVisible: this.appName === 'hernandorena',
                fields: this.getHernandorenaFields(),
                order: 4,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getStatusFields(),
                order: 5,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 6,
            },
        ];

        return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private getLocationFields(): FormField<TareasBioModel>[] {
        return this.registerFields([
            {
                name: this.formType < FormType.DELETION ? 'id_cliente' : 'cliente_nombre',
                vinculatedFields: undefined,
                label: this.clienteName,
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.clientes,
                    isEditable: true,
                    dropdownConfiguration: { valuePrimaryKey: 'id' },
                },
                width: 3,
                conditions: this.conditions({
                    isRequired: true,
                    isVisible: this.shouldShowClientSelector(),
                }),
                order: 1,
            },
            {
                name: this.formType < FormType.DELETION ? 'id_finca' : 'finca',
                vinculatedFields: ['id_cliente'],
                label: this.fincaName,
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.fincas,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it): boolean => this.filterFincaByClient(it.value as FincasModel | null),
                    },
                },
                width: 3,
                conditions: this.conditions({ isRequired: true }),
                order: 2,
            },
            {
                name: this.formType < FormType.DELETION ? 'id_sector' : 'sector',
                vinculatedFields: ['id_finca'],
                label: this.sectorName,
                input: {
                    type: this.sectoresMultiple ? InputType.MULTISELECT_SEARCH : InputType.DROPDOWN,
                    data: this.sectores,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it): boolean => this.filterSectorByFinca(it.value as SectorModel | null),
                    },
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName !== 'hernandorena' }),
                order: 3,
            },
            {
                name: this.formType < FormType.DELETION ? 'ids_parcelas' : 'parcela',
                vinculatedFields: ['id_cliente', 'id_finca', 'id_sector'],
                label: this.parcelasName,
                input: {
                    type: this.parcelasMultiple ? InputType.MULTISELECT_SEARCH : InputType.DROPDOWN_SEARCH,
                    data: this.parcelas,
                    isEditable: true,
                    style: 'min-height: 29px !important;',
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it): boolean => this.filterParcela(it.value as ParcelasModel | null),
                    },
                },
                width: 3,
                conditions: this.conditions({
                    isRequired: true,
                    isVisible: this.showTareasParcela,
                }),
                order: 4,
            },
        ]);
    }

    private getDateAndWorkerFields(): FormField<TareasBioModel>[] {
        return this.registerFields([
            {
                name: 'fecha_receta',
                vinculatedFields: undefined,
                label: this.appName === 'hernandorena' ? 'Fecha' : 'Fecha Orden',
                input: {
                    type: InputType.CALENDAR,
                    isEditable: true,
                    calendarConfiguration: {
                        calendarView: 'date',
                        calendarDateFormat: 'dd/mm/yy',
                    },
                },
                width: 3,
                conditions: this.conditions({ isRequired: this.appName === 'agrotata' }),
                order: 1,
            },
            {
                name: 'fecha_aplicacion',
                vinculatedFields: undefined,
                label: 'Fecha de aplicación',
                input: {
                    type: InputType.CALENDAR,
                    ...this.getDefaultApplicationDateInput(),
                    isEditable: true,
                    calendarConfiguration: {
                        calendarView: 'date',
                        calendarDateFormat: 'dd/mm/yy',
                    },
                },
                width: 3,
                conditions: this.conditions({
                    isRequired: this.appName === 'agrotata',
                    isVisible: this.appName !== 'hernandorena',
                }),
                order: 2,
            },
            {
                name: 'hora_inicio',
                vinculatedFields: undefined,
                label: 'Hora Inicio',
                input: { type: InputType.TIME, isEditable: true },
                width: 3,
                conditions: this.conditions({
                    isRequired: this.appName === 'agrotata',
                    isVisible: environment.features.timeStartStopTareas && this.appName !== 'hernandorena',
                }),
                order: 3,
            },
            {
                name: 'hora_fin',
                vinculatedFields: undefined,
                label: 'Hora Fin',
                input: {
                    type: InputType.TIME,
                    ...this.getDefaultEndTimeInput(),
                    isEditable: true,
                },
                width: 3,
                conditions: this.conditions({
                    isRequired: this.appName === 'agrotata',
                    isVisible: environment.features.timeStartStopTareas && this.appName !== 'hernandorena',
                }),
                order: 4,
            },
            {
                name: 'horas_totales',
                vinculatedFields: ['hora_inicio', 'hora_fin'],
                label: 'Horas',
                input: { type: InputType.ONLY_TEXT, isEditable: true },
                width: 3,
                updateValue: () => this.calculateHorasTotales(),
                conditions: this.conditions({
                    isVisible: environment.features.tareasHorasTotales && this.appName !== 'hernandorena',
                }),
                order: 5,
            },
            {
                name: this.formType < FormType.DELETION ? 'id_trabajadores' : 'trabajadores_nombre',
                vinculatedFields: undefined,
                label: 'Trabajadores',
                input: {
                    type: InputType.MULTISELECT_SEARCH,
                    data: this.trabajadores,
                    isEditable: true,
                    dropdownConfiguration: { valuePrimaryKey: 'id' },
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName !== 'hernandorena' }),
                order: 6,
            },
            {
                name: this.formType < FormType.DELETION ? 'id_maquinaria' : 'maquinaria',
                vinculatedFields: undefined,
                label: 'Maquinaria',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.maquinarias,
                    isEditable: true,
                    dropdownConfiguration: { valuePrimaryKey: 'id' },
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'agrotata' }),
                order: 7,
            },
        ]);
    }

    private getBioFields(): FormField<TareasBioModel>[] {
        return this.registerFields([
            {
                name: 'producto',
                vinculatedFields: undefined,
                label: 'Producto',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.productos,
                    isEditable: true,
                },
                width: 3,
                conditions: this.conditions(),
                order: 1,
            },
            {
                name: 'tipo_plaga',
                vinculatedFields: undefined,
                label: 'Tipo de plaga',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.tipoPlaga,
                    isEditable: true,
                },
                width: 3,
                conditions: this.conditions(),
                order: 2,
            },
            {
                name: 'dosis',
                vinculatedFields: undefined,
                label: 'Dosis',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: this.conditions(),
                order: 3,
            },
            {
                name: 'modo_accion',
                vinculatedFields: undefined,
                label: this.appName === 'hernandorena' ? 'Tipo medida' : 'Modo de acción',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: this.conditions(),
                order: 4,
            },
            {
                name: 'forma_aplicacion',
                vinculatedFields: undefined,
                label: 'Forma de aplicación (intensidad)',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: this.conditions(),
                order: 5,
            },
            {
                name: 'suelta_m2',
                vinculatedFields: undefined,
                label: 'Suelta m²',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName !== 'hernandorena' }),
                order: 6,
            },
            {
                name: 'motivo',
                vinculatedFields: undefined,
                label: 'Motivo',
                input: {
                    type: InputType.TEXTAREA,
                    isEditable: true,
                    textAreaConfiguration: {
                        hasVoiceTranscription: true,
                        canTakePhoto: false,
                        photoField: undefined,
                    },
                },
                width: 6,
                conditions: this.conditions({ isVisible: this.showBioMotivo }),
                order: 7,
            },
        ]);
    }

    private getHernandorenaFields(): FormField<TareasBioModel>[] {
        return this.registerFields([
            {
                name: 'ph_caldo',
                vinculatedFields: undefined,
                label: 'pH Caldo',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'hernandorena' }),
                order: 1,
            },
            {
                name: 'ph_agua',
                vinculatedFields: undefined,
                label: 'pH Agua',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'hernandorena' }),
                order: 2,
            },
            {
                name: 'litros_caldo',
                vinculatedFields: undefined,
                label: 'litros de caldo',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'hernandorena' }),
                order: 3,
            },
            {
                name: 'm2',
                vinculatedFields: undefined,
                label: 'm²',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'hernandorena' }),
                order: 4,
            },
            {
                name: 'cantidad_total_producto',
                vinculatedFields: undefined,
                label: 'Cantidad total producto',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'hernandorena' }),
                order: 5,
            },
        ]);
    }

    private getStatusFields(): FormField<TareasBioModel>[] {
        return this.registerFields([
            {
                name: 'facturado',
                vinculatedFields: undefined,
                label: 'Facturado',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'agrosalvi' }),
                order: 1,
            },
            {
                name: 'factura_albaran',
                vinculatedFields: undefined,
                label: 'Factura/Albarán',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'agrosalvi' }),
                order: 2,
            },
            {
                name: 'orden',
                vinculatedFields: undefined,
                label: this.appName === 'hernandorena' ? 'Estado' : 'Orden',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.estados,
                    isEditable: true,
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.showBioOrden }),
                order: 3,
            },
            {
                name: 'estado_tarea',
                vinculatedFields: undefined,
                label: 'Estado de la Tarea',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.estadoTarea,
                    isEditable: true,
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'onda' || this.appName === 'lacooperativa' }),
                order: 4,
            },
            {
                name: 'empresa_pagadora',
                vinculatedFields: undefined,
                label: 'Empresa Pagadora',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: this.conditions({ isVisible: this.appName === 'onda' || this.appName === 'lacooperativa' }),
                order: 5,
            },
        ]);
    }

    private getHiddenFields(): FormField<TareasBioModel>[] {
        return [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.model.id,
                    isEditable: false,
                },
                width: 2,
                conditions: this.conditions({ isRememberedOnDuplicate: false }),
                order: 1,
            },
            {
                name: 'id_cliente',
                vinculatedFields: ['id_finca'],
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                },
                width: 2,
                updateValue: () => this.resolveClientId(),
                conditions: this.conditions({ isVisible: !this.shouldShowClientSelector() }),
                order: 2,
            },
            {
                name: 'id_usuario',
                vinculatedFields: ['id_finca'],
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                },
                width: 2,
                updateValue: () => this.resolveUserId(),
                conditions: this.conditions(),
                order: 3,
            },
            {
                name: 'cultivo',
                vinculatedFields: ['ids_parcelas'],
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                },
                width: 2,
                updateValue: () => this.getSelectedParcelasValues('cultivo'),
                conditions: this.conditions({ isVisible: this.showTareasParcela }),
                order: 4,
            },
            {
                name: 'variedad',
                vinculatedFields: ['ids_parcelas'],
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                },
                width: 2,
                updateValue: () => this.getSelectedParcelasValues('variedad'),
                conditions: this.conditions({ isVisible: this.showTareasParcela }),
                order: 5,
            },
        ].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private registerFields(fields: FormField<TareasBioModel>[]): FormField<TareasBioModel>[] {
        const visibleFields = fields.filter((field) => field.conditions.isVisible);

        this.fieldNames = this.fieldNames.concat(visibleFields);
        this.fieldLabels = this.fieldLabels.concat(visibleFields.map((field) => field.label));

        return fields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private filterFincaByClient(finca: FincasModel | null): boolean {
        if (finca === null) {
            return true;
        }

        const clientId = this.getSelectedClientId();

        if (!clientId) {
            return true;
        }

        return String(finca.id_cliente ?? '') === clientId;
    }

    private filterSectorByFinca(sector: SectorModel | null): boolean {
        if (sector === null) {
            return true;
        }

        const fincaId = this.getEntityId(this.fincas.selected ?? this.model.id_finca);

        return fincaId.length > 0 && String(sector.id_finca ?? '') === fincaId;
    }

    private filterParcela(parcela: ParcelasModel | null): boolean {
        if (parcela === null) {
            return true;
        }

        if (parcela.activo?.toString() !== '1') {
            return false;
        }

        const selectedSectorIds = this.getSelectedSectorIds();

        if (selectedSectorIds.length > 0) {
            return selectedSectorIds.includes(String(parcela.id_sector ?? ''));
        }

        const fincaId = this.getEntityId(this.fincas.selected ?? this.model.id_finca);

        if (fincaId.length > 0) {
            return String(parcela.id_finca ?? '') === fincaId;
        }

        const clientId = this.getSelectedClientId();

        if (clientId.length > 0) {
            return String(parcela.id_cliente ?? '') === clientId;
        }

        return false;
    }

    private getSelectedSectorIds(): string[] {
        const selected = this.sectores.selected as SectorModel | SectorModel[] | null;

        if (Array.isArray(selected)) {
            return selected.map((sector) => String(sector?.id ?? '')).filter((id) => id.length > 0);
        }

        const sectorId = this.getEntityId(selected ?? this.model.id_sector);

        return sectorId.length > 0 ? [sectorId] : [];
    }

    private getSelectedClientId(): string {
        return this.getEntityId(this.clientes.selected ?? this.client ?? this.model.id_cliente);
    }

    private getEntityId(value: unknown): string {
        if (typeof value === 'object' && value !== null && 'id' in value) {
            return String((value as { id?: unknown }).id ?? '').trim();
        }

        return String(value ?? '').trim();
    }

    private getSelectedParcelasValues(key: 'cultivo' | 'variedad'): string {
        const selected = this.parcelas.selected as ParcelasModel | ParcelasModel[] | null;
        const values = Array.isArray(selected) ? selected : selected ? [selected] : [];

        return values
            .map((parcela) => String(parcela?.[key] ?? '').trim())
            .filter((value) => value.length > 0)
            .join(';');
    }

    private resolveClientId(): string {
        const selectedFinca = this.fincas.selected;
        const fincaClientId = selectedFinca?.id_cliente;
        const modelClientId = this.getEntityId(this.model.id_cliente);
        const storedClientId = this.getEntityId(this.client);

        return String(fincaClientId ?? modelClientId ?? storedClientId ?? '').trim();
    }

    private resolveUserId(): string {
        const selectedFinca = this.fincas.selected;
        const fincaUserId = selectedFinca?.id_usuario;
        const modelUserId = this.getEntityId(this.model.id_usuario);
        const storedUserId = this.getEntityId(this.user?.id);

        return String(fincaUserId ?? modelUserId ?? storedUserId ?? '').trim();
    }

    private shouldShowClientSelector(): boolean {
        return this.hasClients && this.canSeeClientes && !this.client && this.formType === FormType.DUPLICATION && this.user?.tipo !== 'comunero';
    }

    private getDefaultApplicationDateInput(): Partial<{ defaultValue: Date }> {
        if (!environment.features.horaFechaFinActualPorDefecto || this.formType === FormType.EDITION || this.appName === 'sirga') {
            return {};
        }

        return { defaultValue: new Date() };
    }

    private getDefaultEndTimeInput(): Partial<{ defaultValue: string }> {
        if (!environment.features.horaFechaFinActualPorDefecto || this.formType === FormType.EDITION) {
            return {};
        }

        return { defaultValue: moment().format('HH:mm') };
    }

    private normalizeTimeValue(value: unknown): string {
        if (value instanceof Date) {
            return moment(value).format('HH:mm');
        }

        if (typeof value === 'string') {
            return value.trim();
        }

        return '';
    }

    private formatHoursMinutes(startTime: string, endTime: string): string {
        if (!startTime || !endTime) {
            return '';
        }

        const start = moment(startTime, 'HH:mm', true);
        const end = moment(endTime, 'HH:mm', true);

        if (!start.isValid() || !end.isValid()) {
            console.error('Invalid time format. Expected HH:mm.', {
                startTime,
                endTime,
            });

            return '';
        }

        if (end.isBefore(start)) {
            console.warn('End time is before start time.', {
                startTime,
                endTime,
            });

            return '';
        }

        const duration = moment.duration(end.diff(start));
        const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
        const minutes = duration.minutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
